import axios from "axios";

import { ENDPOINT, bookedEnv } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";
import { getBrandTenantField } from "../../utils/booking/brandTenant";

export async function saveItineraryDetailsAPI(
  accessJWT: string,
  payload: any,
  method: "POST" | "PUT",
  itineraryId?: string,
  signal?: any
) {
  let tempSignal = signal;
  if (!signal) tempSignal = null;

  const URL = `${ENDPOINT}/app/v1/users/itineraries`;
  let config = getHeaderConfig(tempSignal, accessJWT);
  let body = {
    ...payload,
    bookedEnv,
    ...getBrandTenantField(),
  };
  // Backend PUT schema (updateItinerarySchema) requires `id` as the primary
  // key, while POST uses `itineraryId` as a nullable reference field.
  if (itineraryId) {
    body = method === "PUT"
      ? { ...body, id: itineraryId }
      : { ...body, itineraryId: itineraryId };
  }
  if (!hasUsableJWT(accessJWT, "saveItineraryDetailsAPI")) return null;
  try {
    if (!payload?.userId) return;
    if (body?.userId?.id) {
      body.userId = body.userId.id;
    }
    let response = null;
    consoleLog(["SAVE ITINERARY PAYLOAD", body]);
    if (method === "POST") response = await axios.post(URL, encryptData(body), config);
    else response = await axios.put(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["SAVE ITINERARY RESPONSE", decryptedData]);
      return decryptedData && decryptedData !== "undefined" ? JSON.parse(decryptedData) : null;
    } else return null;
  } catch (error) {
    return error;
  }
}
